<script>
  /* ____________ Mobile Detection ____________ */
  import UA from 'ua-parser-js';
    const ua = new UA();
    let isMobile = ua.getResult().device['type'] == 'mobile';

  import { getContext, onMount } from "svelte";
  import {
    Map,
    Marker,
    Geocoder,
    contextKey,
    controls,
  } from "@beyonk/svelte-mapbox";
  const { GeolocateControl, NavigationControl, ScaleControl } = controls;
  let mapComponent;

  import MapScripting from "./MapScripting.svelte";
  import MapExpand from "./MapExpand.svelte";
  import CampusMarker from "./CampusMarker.svelte";


  export let expanded = null;
  export let zoom;
  let showMarkers = false;

  $: if(expanded !== null){
    if(mapComponent){
      mapComponent.resize();
    }

    if(expanded){
      showMarkers = true;
    } else {
      showMarkers = false;
    }
  }
</script>

<div class="map">
<Map
  accessToken="pk.eyJ1IjoiemRiLSIsImEiOiJjazd3dTh6d2cwNDVqM2ZtazRhYzh0NjMzIn0.kEWM1FnfWEnlRu6pyxDOmw"
  style="mapbox://styles/zdb-/clifdnm2x003501od70e98akc"
  zoom={zoom}
  bind:this={mapComponent}
  on:recentre={(e) => console.log(e.detail.center)}
  options={{
    pitch: 100,
    bearing: 180,
    center: [-83.61306442148566, 41.65833217081001],
    // attributionControl: false,
    // logoPosition: 'bottom-right',
    
    
  }}
>
  {#if !isMobile}
  <CampusMarker 
    text={'Go to Health Science Campus'} 
    goto={[-83.61569894403925, 41.61907649517585]}
    zoom={16.5}
    lng={-83.6145673416037} 
    lat={41.65112774336532}
    iconPosition={'up'} 
    rotation={0} 
    iconRotation={-78}
    show={showMarkers}
  />
  <CampusMarker 
    text={'Go to Main Campus'} 
    goto={[-83.61306442148566, 41.65833217081001]} 
    zoom={zoom}
    lng={-83.6194080824238}
    lat={41.618733581131494}
    iconPosition={'down'} 
    rotation={0} 
    iconRotation={110}
    show={showMarkers}
  />
  {/if}
  
  {#if isMobile}
  <CampusMarker 
    text={'Go to Health Science Campus'} 
    goto={[-83.61586322630995, 41.61924914873981]}
    zoom={15.75}
    lng={-83.61274881581883}
    lat={41.64777490626261}
    iconPosition={'up'} 
    rotation={0} 
    iconRotation={-78}
    show={showMarkers}
  />
  <CampusMarker 
    text={'Go to Main Campus'} 
    goto={[-83.61306442148566, 41.65833217081001]} 
    zoom={zoom}
    lng={-83.6157735819663}
    lat={41.622495613605}
    iconPosition={'down'} 
    rotation={0} 
    iconRotation={95}
    show={showMarkers}
  />
  {/if}
  
  {#if isMobile}
    <!-- <NavigationControl position={'top-right'} options={{ visualizePitch: true }}  /> -->
    <GeolocateControl position={'top-right'} />
    <!-- <ScaleControl /> -->
  {/if}

  <MapScripting
    buildingColor="#FFD200"
    buildingHoverColor="#134FC9"
    buildingBgColor="#003E7E"
    buildingPopupColor="#FFD200"
    popupBgColor="#002a55"
  />
</Map>
</div>

<style>
:global(.map canvas) {
  width: 100% !important;
  height: 100% !important;
}

:global(.mapboxgl-ctrl-top-right) {
    top: 65px !important;
    right: 18px !important;
}
</style>
